import { LABEL} from '../apiConstant';
import BaseApi from '../baseApi';

class LabelApi extends BaseApi {

    getList() {
        return this.get(`${LABEL}/list`);
    }
    
    bindingLabel(param) {
        return this.post(`${LABEL}/bind`,param);
    }

    createLabel(param) {
        return this.post(`${LABEL}/add`, param);
    }

    updateLabel(param) {
        return this.post(`${LABEL}/update`, param);
    }

    deleteLabel(param) {
        return this.post(`${LABEL}/delete/${param}`);
    }
}
export default LabelApi;
